import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { SessionService } from './session.service';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AcrescimosService {
  private urlServer = environment.URL_API;

  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) {}

  atualizar(matricula: string, idOrgao: string): Observable<any> {
    return this.http.put(`${this.urlServer}/acrescimos/`, {matriculaOrgao:{matricula,idOrgao}});
  }

  resumo(matricula: string, idOrgao: string): Observable<any> {
    return this.http.get(`${this.urlServer}/acrescimos/resumo/matricula/${matricula}/orgao/${idOrgao}`);
  }

  getAcrescimos(matricula: string, orgaoId: string): Observable<any> {
    const token = this.sessionService.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    return this.http.get(
      this.urlServer +
        '/acrescimos/matricula/' +
        matricula +
        '/orgao/' +
        orgaoId,
      { headers }
    );
  }

  /**
   * Upload multipart/form-data para Acréscimos:
   * /files/upload?matricula=&idOrgao=&idOrigem=&tipoDocumento=
   *
   * tipoDocumento: ajuste se a API exigir outro valor (ex.: 'DOCUMENTO_ACRESCIMO_PREVIDENCIARIO')
   */
  uploadAcrescimoDocumento(
    idOrigemAcrescimo: number,
    file: File,
    tipoDocumento = 'DOCUMENTO_REPASSE_PREVIDENCIARIO',
    idTipoDocumento?: number
  ) {
    const token = this.sessionService.token;
    const matricula = this.sessionService.beneficiario.matricula;
    const idOrgao = this.sessionService.beneficiario.orgao.id;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      // NÃO setar Content-Type manualmente com FormData
    });

    let params = new HttpParams()
      .set('matricula', String(matricula))
      .set('idOrgao', String(idOrgao))
      .set('idOrigem', String(idOrigemAcrescimo))
      .set('tipoDocumento', tipoDocumento);
    if (idTipoDocumento != null) params = params.set('idTipoDocumento', idTipoDocumento);

    const formData = new FormData();
    formData.append('file', file);

    return this.http.post(`${this.urlServer}/files/upload`, formData, {
      headers,
      params,
    });
  }

  /** Download por hash: GET /files/download?hash=... (retorna Blob + headers) */
  downloadDocumentoPorHash(hash: string): Observable<HttpResponse<Blob>> {
    const token = this.sessionService.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      Accept: '*/*',
    });

    const params = new HttpParams().set('hash', hash);

    return this.http.get(`${this.urlServer}/files/download`, {
      headers,
      params,
      responseType: 'blob',
      observe: 'response',
    });
  }

  /** Delete por hash: DELETE /files?hash=... */
  deleteDocumentoPorHash(hash: string) {
    const token = this.sessionService.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    const params = new HttpParams().set('hash', hash);

    return this.http.delete(`${this.urlServer}/files`, { headers, params });
  }

  /**
   * Prepara o cadastro de repasse previdenciário para acréscimo
   * GET /acrescimos/preparar-cadastro-repasse-acrescimos/{idAcrescimo}
   */
  prepararCadastroRepasseAcrescimo(idAcrescimo: number): Observable<any> {
    const token = this.sessionService.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    return this.http.get(
      `${this.urlServer}/acrescimos/preparar-cadastro-repasse-acrescimos/${idAcrescimo}`,
      { headers, params: {matricula:this.sessionService.beneficiario.matricula,idOrgao:this.sessionService.beneficiario.orgao.id} }
    );
  }

  /**
   * Salva repasse previdenciário para acréscimo
   * POST /acrescimos/save-repasse (mesmo endpoint de deduções segundo collection)
   */
  salvarRepasseAcrescimo(payload: any): Observable<any> {
    const token = this.sessionService.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    return this.http.post(
      `${this.urlServer}/acrescimos/save-repasse`,
      payload,
      { headers }
    );
  }

  /**
   * Upload de documento de repasse previdenciário
   * POST /files/upload?matricula=&idOrgao=&idOrigem=&tipoDocumento=DOCUMENTO_REPASSE_PREVIDENCIARIO
   */
  uploadDocumentoRepasse(idOrigem: number, file: File): Observable<any> {
    const token = this.sessionService.token;
    const matricula = this.sessionService.beneficiario.matricula;
    const idOrgao = this.sessionService.beneficiario.orgao.id;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    const params = new HttpParams()
      .set('matricula', String(matricula))
      .set('idOrgao', String(idOrgao))
      .set('idOrigem', String(idOrigem))
      .set('tipoDocumento', 'DOCUMENTO_REPASSE_PREVIDENCIARIO');

    const formData = new FormData();
    formData.append('file', file);

    return this.http.post(`${this.urlServer}/files/upload`, formData, {
      headers,
      params,
    });
  }
}
